<template>
  <div class="container">
    <div class="head">
      <h2>
        러닝정보<span>{{ currentViewName }}</span>
      </h2>
      <div class="util">
        <button class="favor-button" id="addToHome">
          <span class="hide">즐겨찾기</span>
        </button>

        <button
          class="ham-button"
          @click="toggleMenu"
          :class="{ active: isNavVisible }"
        >
          <span class="hide">메뉴열고닫기</span>
        </button>
      </div>
      <nav :class="{ active: isNavVisible }">
        <ul>
          <!-- 메뉴 항목을 동적으로 렌더링 -->
          <li v-for="(route, index) in routes" :key="route.name">
            <!-- id와 for 속성에 index 사용 -->
            <input
              type="radio"
              :id="`navCheck-${index}`"
              name="navCheck"
              :checked="checkedStates[index]"
              @change="updateCheckedState(index, $event)"
            />
            <label :for="`navCheck-${index}`"></label>
            <router-link :to="route.path" @click="toggleMenu">
              {{ route.name }}
            </router-link>
          </li>
          <li>
            <span class="icon"></span>
            <a href="https://www.instagram.com/kang.sukhee.run" target="_blank">Contact</a></li>
        </ul>
      </nav>
    </div>
    <router-view class="contents" ref="childRef" />
    <a class="insta" href="https://www.instagram.com/kang.sukhee.run/"
      >kang.sukhee.run<span id="counter"
        >&nbsp; today:{{ todayCount }} / total:{{ totalCount }}</span
      ></a
    >
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

// Firebase 초기화
import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, set } from "firebase/database"; // 필요한 함수 import

export default {
  name: "App",
  data() {
    return {
      isNavVisible: false, // 메뉴 보이기/숨기기 상태
      routes: [], // 라우터 정보 저장
      currentViewName: "", // 현재 화면 이름
      todayCount: 0, // 오늘 방문자 수
      totalCount: 0, // 누적 방문자 수
      checkedStates: [],
    };
  },
  created() {
    // Load saved checked states from localStorage
    const savedStates = JSON.parse(localStorage.getItem("navCheckStates"));
    if (savedStates && savedStates.some((state) => state)) {
      // 저장된 상태가 있으면 그대로 사용
      this.checkedStates = savedStates;
    } else {
      // 저장된 상태가 없으면 첫 번째 항목 체크
      this.checkedStates = this.routes.map((_, i) => i === 0);
      localStorage.setItem("navCheckStates", JSON.stringify(this.checkedStates));
    }
  },
  mounted() {
    useHead({
      title: "페이스 계산기",
      meta: [],
    });
    // 라우트 정보 가져오기
    this.routes = this.$router.options.routes;

    // 초기 화면명을 업데이트
    this.updateCurrentViewName(this.$route);

    // 라우트 변경 시 화면명 업데이트
    this.$router.afterEach((to) => {
      this.updateCurrentViewName(to);
    });

    // LocalStorage에서 저장된 상태 가져오기
    const savedStates = JSON.parse(localStorage.getItem("navCheckStates"));
    if (savedStates) {
      const checkedIndex = savedStates.findIndex((state) => state); // true 상태의 index 찾기
      if (checkedIndex !== -1) {
        const defaultRoute = this.routes[checkedIndex]; // 해당 index의 라우트
        if (defaultRoute && this.$route.path !== defaultRoute.path) {
          // 현재 라우트가 다를 경우에만 이동
          this.$router.push(defaultRoute.path);
        }
      }
    } else {
      // 초기 상태가 없으면 첫 번째 메뉴를 기본으로 설정
      this.checkedStates[0] = true;
      localStorage.setItem("navCheckStates", JSON.stringify(this.checkedStates));
    }

    // Firebase 앱 초기화
    const firebaseConfig = {
      apiKey: "AIzaSyBRTJR6NnDOOT_5px-iGt2YXUW2sFXZBDo",
      authDomain: "calcul-f8059.firebaseapp.com",
      databaseURL: "https://calcul-f8059-default-rtdb.firebaseio.com",
      projectId: "calcul-f8059",
      storageBucket: "calcul-f8059.firebasestorage.app",
      messagingSenderId: "332262457868",
      appId: "1:332262457868:web:e80b18bde1a1d7f0f3a429",
      measurementId: "G-ZFXXD1Q4RX",
    };

    initializeApp(firebaseConfig); // Firebase 앱 초기화

    this.updateVisitCounts(); // 방문자 수 업데이트 호출
    this.fetchVisitCounts();

    // 초기 라우트에 따른 body 클래스 설정
    this.updateBodyClass(this.$route);

    // 라우트 변경 시 body 클래스 업데이트
    this.$router.afterEach((to) => {
      this.updateBodyClass(to);
    });
  },
  methods: {
    toggleMenu() {
      this.isNavVisible = !this.isNavVisible; // 상태를 반전
    },
    updateCheckedState(index, event) {
      // 모든 상태를 초기화하고 선택한 index만 true로 설정
      this.checkedStates = this.routes.map((_, i) => i === index && event.target.checked);

      // LocalStorage에 저장
      localStorage.setItem("navCheckStates", JSON.stringify(this.checkedStates));

    },
    updateBodyClass(route) {
      // 현재 body 클래스 목록 초기화
      document.body.className = "";

      // meta.class 값을 가져와서 적용
      const routeClass = route.meta?.class || "default";
      document.body.classList.add(`page-${routeClass}`);
    },
    updateCurrentViewName(route) {
      const selectedRoute = this.routes.find((r) => r.name === route.name);
      if (selectedRoute) {
        this.currentViewName = selectedRoute.name;
      }
    },
    async fetchVisitCounts() {
      try {
        const db = getDatabase();
        const visitLogsRef = ref(db, "visitLogs");

        // `visitLogs` 데이터를 가져옵니다.
        const visitLogsSnapshot = await get(visitLogsRef);

        if (!visitLogsSnapshot.exists()) {
          console.log("방문 기록이 없습니다.");
          this.todayCount = 0;
          this.totalCount = 0;
          return;
        }

        const visitLogs = visitLogsSnapshot.val();
        const todayDate = new Date().toISOString().split("T")[0];
        let todayVisitorCount = 0;
        let totalVisitorCount = 0;

        // 날짜별 방문자 수를 계산
        for (const date in visitLogs) {
          const dailyVisitors = Object.keys(visitLogs[date]).length; // 해당 날짜의 방문자 수

          totalVisitorCount += dailyVisitors; // 총 방문자 수 증가

          if (date === todayDate) {
            todayVisitorCount = dailyVisitors; // 오늘 방문자 수 저장
          }
        }

        this.todayCount = todayVisitorCount;
        this.totalCount = totalVisitorCount;

        console.log(
          `오늘 방문자: ${this.todayCount}, 총 방문자: ${this.totalCount}`
        );
      } catch (error) {
        console.error("방문자 수를 계산하는 데 오류가 발생했습니다:", error);
        this.todayCount = 0;
        this.totalCount = 0;
      }
    },
    async updateVisitCounts() {
      const ip = await this.getUserIP();
      const todayDate = new Date().toISOString().split("T")[0];
      const safeIP = ip ? ip.replace(/\./g, "_") : null;

      if (!safeIP) {
        console.error("유효한 IP를 가져오지 못했습니다.");
        return;
      }

      try {
        const db = getDatabase();
        const visitLogsRef = ref(db, `visitLogs/${todayDate}/${safeIP}`);
        const todayCountRef = ref(db, "visitCounts/today");
        const totalCountRef = ref(db, "visitCounts/total");

        // 이미 방문 기록이 있는지 확인
        const visitLogSnapshot = await get(visitLogsRef);

        if (!visitLogSnapshot.exists()) {
          // 방문 기록이 없으면 새로운 기록 추가
          await set(visitLogsRef, true);

          // 오늘 방문자 수 업데이트
          const todaySnapshot = await get(todayCountRef);
          const newTodayCount = todaySnapshot.exists()
            ? todaySnapshot.val() + 1
            : 1;
          await set(todayCountRef, newTodayCount);

          // 총 방문자 수 업데이트
          const totalSnapshot = await get(totalCountRef);
          const newTotalCount = totalSnapshot.exists()
            ? totalSnapshot.val() + 1
            : 1;
          await set(totalCountRef, newTotalCount);

          console.log("방문자 수가 성공적으로 업데이트되었습니다.");
        } else {
          console.log("오늘 이미 방문한 사용자입니다.");
        }
      } catch (error) {
        console.error(
          "방문자 수를 업데이트하는 데 오류가 발생했습니다:",
          error
        );
      }
    },
    async getUserIP() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        return data.ip;
      } catch (error) {
        console.error("IP를 가져오는 데 오류가 발생했습니다:", error);
        return null;
      }
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}
.container {
  /* max-width: 400px; */
  padding: 0 1em 20px;
  position: relative;
  margin: 0 auto;
}
.head {
  position: relative;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.head > h2 {
  font-size: 1.2em;
  margin-block-start: 0em;
  margin-block-end: 0em;
  text-align: left;
  font-weight: 800;
}

.head > h2 > span {
  font-size: 0.7em;
  display: inline-block;
  margin-left: 0.3em;
  /* opacity: 0.4; */
}
.head > h2 > span:before {
  content: "|";
  display: inline-block;
  margin: 0 5px;
  opacity: 0.4;
}
.hide {
  position: absolute;
  overflow: hidden;
  height: 1px;
  width: 1px;
  z-index: -1;
  overflow: hidden;
}

.head .util {
  display: flex;
  align-items: center;
}

.head .favor-button {
  width: 32px;
  height: 32px;
  border: 0;
  background: url(@/assets/images/icon-favorite-on.png);
  background-size: 100% auto;
  opacity: 0;
}

.ham-button {
  width: 32px;
  height: 32px;
  border: 0;
  background: 0;
  position: relative;
  z-index: 11;
}
.ham-button::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(@/assets/images/icon-menu.png);
  background-size: 100% auto;
}
.ham-button.active::before {
  width: 18px;
  height: 18px;
  background-image: url(@/assets/images/icon-menu-close.png);
}
nav {
  position: fixed;
  display: none !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background: rgba(2, 2, 2, 0.2);
  backdrop-filter: blur(2px);
  z-index: 10;
}
nav.active {
  display: block !important;
}
nav ul {
  padding-top: 60px;
  background: #fff;
  box-shadow: 0 6px 11px rgba(0, 0, 0, 0.1);
  height: 100%;
  width: 200px;
  z-index: 10;
  position: absolute;
  right: 0;
}
nav ul li:first-child {
  /* border-top: 1px solid #e5e5e5; */
}
nav ul li {
  cursor: pointer;
  text-align: left;
  position: relative;
  /* border-bottom: 1px solid #e5e5e5; */
}
nav ul li a {
  display: block;
  padding: 17px;
  text-decoration: none;
  color: #7b7b7b;
  font-weight: bold;
  font-size: 14px;
  padding-left: 40px;
}
nav ul li a.router-link-active {
  background-color: #5c445d;
  color: #fff;
}
nav ul li input[type="radio"]{
  display: none;
}
nav ul li input[type="radio"] + label{
  left: 0px;
  position: absolute;
  width: 37px;
  height: 48px;
}
nav ul li input[type="radio"] + label::before{
  content: '';
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  position: absolute;
  display: block;
  width: 17px;
  height: 17px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgoJPHRpdGxlPmZyZWUtaWNvbi1ob21lLTE3Mjg4MTMxPC90aXRsZT4KCTxkZWZzPgoJCTxpbWFnZSAgd2lkdGg9IjIxIiBoZWlnaHQ9IjIyIiBpZD0iaW1nMSIgaHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFCVUFBQUFXQ0FNQUFBQVlYU2NLQUFBQUFYTlNSMElCMmNrc2Z3QUFBTEZRVEZSRjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuNStmbjUrZm41K2ZuR1BFMmxBQUFBRHQwVWs1VEFCSWkyUE5KTituLysyZFI5cEVCYi8yaEJnT1N2UkFLc05RZkU4VG1NeVRhOUV6ZUdrM1M4RzBDZGF4MHFmNjIvSTFpTUdZdnFLb21uMUFuTkpDUUFBQUFyVWxFUVZSNG5HTmtnQUZHeG44SU5vekJ4TWpJK0J0ZGxJMlJFYWo2RzZvb04rTWZFTVhLK0FsSmxKL3hCMFNXay9FZFRGU1k4UXZjSGw3R1Z4QlJjY1lQREFnZ3lQZ01KQ3JOK0lZQkdZZ3lQbUpnbEdkOHdZQUtKQm52TVNvL1pVQUhqTktNcWtBTnFFQWU2QjhHclh0b29zcFhnYmJwM0VFVFZiMU1UVkcxZDhLTU56QkVOYzh6R0YzREVHWDZ4bUI4bFVoUm5UTU1wcGNSb3FhTW9ERCt6M1NDUVZ3SkhKL014eGdBdGtZelpKK2haNXNBQUFBQVNVVk9SSzVDWUlJPSIvPgoJPC9kZWZzPgoJPHN0eWxlPgoJPC9zdHlsZT4KCTx1c2UgaWQ9IkJhY2tncm91bmQiIGhyZWY9IiNpbWcxIiB4PSIyIiB5PSIxIi8+Cjwvc3ZnPg==");
  background-size: 100% auto;
}
nav ul li input[type="radio"]:checked + label::before{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAACxAAAAsQHGLUmNAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAV1JREFUSInllM8rBGEYxz/P7pTCiVIcN/InOPAP+JXEv4ALzVDuzg47s3HgJgeiJC6KWhzYEyW5cHIQF7UulNY+Dtus2cXszM4clM/t+07v9/P2NO8LfwlN06I2qTB7EoHLbVIkOEe4Upv+WAXq0IOQA7qBZoR9dZiKRaAZRoFjoM2zbAAr6pBRRfz2+37UDCZKusZB1skzIQu8BxboNkkesBFm/A7gIYsyJrPkawp0lUZe2UAYCVjucoPBoExz/6tAl2mlwB7QG7Lc5RFhWEwu3IXybDVNJwVyEcoB2lFO1WHom4AEh0BXhHKXJmBXl+ioFBQxEa4j1wsvCHM881SKHtRhHliMqNgRi3E3VP7fgkYsB+XDGwO/RfXyvwQKnAEHUDnneASCLRZ9YjGAMhm/QLn1pMv4BXUSZkRfdyQZ/L4YVSVHKFs/iIsUOCmnBu54Y43Su1PNZlB5LHwC6+haXVU2KtAAAAAASUVORK5CYII=");
}
nav ul li .icon{
  width: 17px;
  height: 17px;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  position: absolute;
  display: block;
  background-image: url("data:image/svg+xml;base64,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");
  background-size: 100% auto;
  opacity: .5;
}
.contents {
  max-width: 500px;
  margin: 0 auto;
}

.tabs {
  display: flex;
  gap: 1px;
  font-size: 1em;
}

.tab {
  padding: 1.2em 0;
  background-color: #ccdfff;
  color: #4881da;
  font-size: 0.8em;
  flex: 1;
  position: relative;
  text-align: center;
}

.tab:not(.active):after {
  content: "";
  display: block;
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 0.8em;
  background: linear-gradient(rgba(49, 94, 169, 0), rgba(49, 94, 169, 0.3));
}

.tab:first-child {
  border-radius: 0.8em 0 0 0;
}

.tab:last-child {
  border-radius: 0 0.8em 0 0;
}

.tab strong {
  font-size: 1.4em;
  font-weight: 800;
  pointer-events: none;
}

.tab.active {
  color: #fff;
  background-color: #4881da;
}

.calcul {
  background-color: #4881da;
  padding: 1.3em 1.3em 1em;
  border-radius: 0 0 0.8em 0.8em;
  color: #fff;
}

.calcul-bottom {
  background-color: #5b94eb;
  margin: 1.3em -1.3em -1em;
  padding: 0.7em 1.3em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 0.8em 0.8em;
}

.calcul-bottom > button {
  /* padding: .5em; */
  font-size: 1.3em;
  background-color: #24487f;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 0.3em;
  height: 2em;
  width: 4em;
  margin-left: 1em;
}
.calcul > * + * {
  /* margin-top: 1.4em; */
}
.calcul > *:not(:last-child) {
  /* margin-bottom: 1.4em; */
}
.calcul > *:only-child {
  margin-bottom: 0 !important;
}

.calcul-bottom > button:only-child {
  width: 100%;
  margin-left: 0;
}

.calcul-bottom > button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.insta {
  position: fixed;
  bottom: 1em;
  right: 1em;
  text-decoration: none;
  font-size: 11px;
  color: #999;
  background: rgba(255, 255, 255, 0.5);
  display: block;
  padding: 0.5em;
  border-radius: 0.3em;
}

.insta::before {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  background: url("data:image/svg+xml;base64,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")
    no-repeat;
  background-size: 100% auto;
  vertical-align: middle;
  margin: -1px 2px 0 0;
}
.insta > span {
  font-size: 9px;
}

.page-track .tab {
  background-color: #ffd8d2;
  color: #b7402e;
}
.page-track .tab.active,
.page-track .calcul {
  background-color: #b7402e;
  color: #fff;
}
.page-track .tab:not(.active):after {
  background: linear-gradient(rgb(119 83 77 / 0%), rgb(119 83 77 / 30%));
}
.page-track .calcul-bottom {
  background-color: #e37b6c;
}
.page-track .calcul-bottom > button {
  background-color: #81281a;
}
.page-track .tit-unit {
  background-color: #b7402e;
}
body.page-track {
  background-color: #fff5f5;
}

.page-vo2max .tab {
  background-color: #ffc8c8;
  color: #e11b22;
}
.page-vo2max .tab.active,
.page-vo2max .calcul {
  background-color: #e11b22;
  color: #fff;
}
.page-vo2max .tab:not(.active):after {
  background: linear-gradient(rgb(189 92 76 / 0%), rgb(189 92 76 / 30%));
}
.page-vo2max .calcul-bottom {
  background-color: #ff484e;
}
.page-vo2max .calcul-bottom > button {
  background-color: #9d0107;
}
.page-vo2max .tit-unit {
  background-color: #e11b22;
}
body.page-vo2max {
  background-color: #fff1f1;
}

body.page-treadmill {
  background-color: #f1f1f1;
}
.page-treadmill .tab.active,
.page-treadmill .calcul {
  background-color: #2b2e3d;
  color: #fff;
}

.page-treadmill .calcul-bottom {
  background-color: #474a5b;
}
.page-treadmill .calcul-bottom > button {
  background-color: #1f212b;
}

body.page-race {
  background-color: #f9f1ff;
}

.txt-help {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 15px;
  text-align: right;
}
</style>
